// extracted by mini-css-extract-plugin
export default {"container":"PageErrorUi_container__6m9aw","image":"PageErrorUi_image__zU5ew","content":"PageErrorUi_content__xUX54","msg":"PageErrorUi_msg__P4WjZ"};